import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('over_time')
export class OverTimeEntity {

    @PrimaryGeneratedColumn('increment', {
        name: "ot_id"
    })
    otId: number;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'employee_code'
    })
    employeeCode: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'employee_name'
    })
    employeeName: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'date'
    })
    date: string;

    @Column({
        name: 'in_time'
    })
    inTime: Date;

    @Column({
        name: 'out_time'
    })
    outTime: Date;

    @Column('int', {
        nullable: false,
        name: 'working_hours'
    })
    workingHours: number;

    @Column('varchar', {
        nullable: false,
        name: 'ot_type'
    })
    otType: string;

    @Column('varchar', {
        nullable: false,
        name: 'ot_hours'
    })
    otHours: string;

    @Column({
        type: 'enum',
        enum: LeaveApprovalStatusEnum,
        nullable: true,
        default: LeaveApprovalStatusEnum.OPEN,
        name: 'status'
    })
    status: LeaveApprovalStatusEnum;

    @Column('int', {
        nullable: true,
        name: 'month'
    })
    month: number;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: false,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}